<template>
	<EventLayout :event="event" :subtitle="trans('events.certificates.title')">
		<template #actions>
			<StoreCertificate
				certifiable-type="event"
				:certifiable-id="event.id"
				:return-url="returnUrl"
				:return-label="returnLabel"
			/>
		</template>
		<CertificatesManager :certificates="event.certificates" :return-url="returnUrl" :return-label="returnLabel"/>
	</EventLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {defineProps, type Ref, ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import EventLayout from '@/Layouts/EventLayout.vue'
import StoreCertificate from '@/Components/Certificates/StoreCertificate.vue'
import CertificatesManager from '@/Components/Certificates/CertificatesManager.vue'

const props = defineProps<{
	event:Event,
}>()

const event:Ref<Event> = ref(props.event)
const returnUrl:Ref<string> = ref(route('events.enrollments.certificates', event.value.id))
const returnLabel:Ref<string> = ref(trans('events.certificates.title'))
</script>